// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TerceraComboBox } from './TerceraComboBox';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
export class QuickTableComboBox extends TerceraComboBox {
    constructor(initProps, data, callback, rect) {
        super(initProps);
        const rowData = data.cell.QuickTableEditingInfo.GetDataHandler(data.row);
        const items = [];
        let selectedValue = null;
        for (let i = 0; i < rowData.length; i++) {
            items.push({ type: NewContextMenuItemType.Default, text: rowData[i].text, value: rowData[i].value });
            const isSelected = rowData[i].selected;
            if (!isNullOrUndefined(isSelected) && isSelected) {
                selectedValue = rowData[i].value;
            }
        }
        void super.set({ items });
        if (!isNullOrUndefined(selectedValue)) {
            super.setItembyValue(selectedValue);
        }
        else {
            super.setItembyValue(data.cell.value);
        }
        this.tag = data;
        this.callBack = callback;
        super.setBounds(rect.X, rect.Y, rect.Width, rect.Height);
        void super.set('isPosAbsolute', true);
        void super.set('hasAdaptiveMenu', true);
    }
    oncomplete() {
        super.setFocus();
        super.MenuShow();
    }
    lostFocus() {
        super.lostFocus();
        const selectedItem = this.get('selectedItem');
        if (isNullOrUndefined(selectedItem) || selectedItem.value === this.tag.cell.value) {
            this.callBack(null, this.tag);
        }
        else {
            this.callBack(selectedItem.value, this.tag);
        }
    }
}
TerceraComboBox.extendWith(QuickTableComboBox, {
    data: function () {
        return {
            zIndex: 1
        };
    }
});
